<template>
    <div
        class="checkbox-group checkbox-group--full"
    >
        <div
            class="group-controls"
            v-if="!readonly"
        >
            <span
                class="help-text link select-all"
                @click="selectAll"
                >
                Выделить все
            </span>
            <span
                    class="help-text link select-all"
                    @click="unselectAll"
            >
                Очистить выбор
            </span>
        </div>

        <div
            class="checkbox-group__checkboxes checkbox-group__checkboxes--full"
        >
            <checkbox
                    v-for="option in optionsToShow"
                    :key="option.key"
                    :input-key="option.key"
                    :label="option.value"
                    :value="isOptionChecked(option.key)"
                    :readonly="readonly"
                    @input="emitInput(option.key)"
            />
        </div>
    </div>
</template>

<script>
  import AutoFieldMixin from '../../mixins/AutoField'
  import Checkbox from './Checkbox'

  export default {
  name: 'CheckboxGroup',
  mixins: [AutoFieldMixin],
  components: {
    Checkbox
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: Array,
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {

    }
  },
  computed: {
    isValueTypeValid() {
      return Array.isArray(this.value)
    },
    defaultValue() {
      return []
    },
    optionsToShow() {
        return this.options
    }
  },
  methods: {
    isOptionChecked(optionKey) {
      return Array.isArray(this.value) && this.value.includes(optionKey)
    },
    valueToSendFromEvent(newItem) {
      if (Array.isArray(newItem)) {
        return newItem
      }

      const old = Array.isArray(this.value) ? this.value : []
      if (old.includes(newItem)) {
        const index = old.indexOf(newItem)
        return [...old.slice(0, index), ...old.slice(index + 1)]
      } else {
        return [...old, newItem]
      }
    },
    valueIsEmpty(value) {
      return JSON.stringify(value) === JSON.stringify(this.defaultValue)
    },
    selectAll() {
        this.emitInput(this.optionsToShow.map(option => option.key))
    },
    unselectAll() {
        this.emitInput([])
    }
  }
}
</script>

<style lang="sass" scoped>
    .checkbox-group
        margin-top: gridSteps(-1)

    .checkbox-group__checkboxes--full
        overflow-y: auto
        max-height: gridSteps(20)

    .group-controls
        margin-bottom: gridSteps(1)
        display: flex

    .select-all
        margin-right: gridSteps(1)
</style>
